import request, { PATCH } from '../../utils/request';

export default body => request('/request-records', { method: PATCH, body });
